module.exports = __webpack_public_path__ + "img/observa4.ba8b5539.jpg";